// extracted by mini-css-extract-plugin
export default {"changeLink":"SR-z","disabled":"TR-z","inline":"UR-z"};